module.exports = __webpack_public_path__ + "r-v3/img/ico_menu_share_note.11c6219b.svg";